/** OSM tile opacity for floor-map and fullscreen blender (must stay 0–1). */
export const FLOOR_LEAFLET_TILE_OPACITY = 0.2;
